import { auth } from "../firebase"

async function login(email, password) {
  let user = await auth.signInWithEmailAndPassword(email, password)
  return user.user
}

export default login
